<p-select
  name="calendar"
  [options]="options"
  [(ngModel)]="selectedCalendar"
  [optionLabel]="'name'"
  size="small"
  (onChange)="this.notifySelection()"
  fluid
></p-select>
